<script>
import ConversationCard from './widgets/conversation/ConversationCard.vue';
export default {
  components: {
    ConversationCard,
  },
  inject: [
    'selectConversation',
    'deSelectConversation',
    'assignAgent',
    'assignTeam',
    'assignLabels',
    'removeLabels',
    'updateConversationStatus',
    'toggleContextMenu',
    'markAsUnread',
    'markAsRead',
    'assignPriority',
    'isConversationSelected',
    'deleteConversation',
  ],
  props: {
    source: {
      type: Object,
      required: true,
    },
    teamId: {
      type: [String, Number],
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    topicId: {
      type: [String, Number],
      default: 0,
    },
    conversationType: {
      type: String,
      default: '',
    },
    foldersId: {
      type: [String, Number],
      default: 0,
    },
    // MakerHub / Smith3D company inbox-group view ('mk' | 's3'); see Sidebar.vue.
    company: {
      type: String,
      default: '',
    },
    // Active inbox-rail search term — highlights matches in the message preview.
    searchTerm: {
      type: String,
      default: '',
    },
    showAssignee: {
      type: Boolean,
      default: false,
    },
    // Drops the channel line above the name — used by the pinned section, where
    // the inbox is already implied by the view and the rows should stay tight.
    hideInboxName: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <ConversationCard
    :active-label="label"
    :topic-id="topicId"
    :team-id="teamId"
    :folders-id="foldersId"
    :company="company"
    :chat="source"
    :search-term="searchTerm"
    :conversation-type="conversationType"
    :selected="isConversationSelected(source.id)"
    :show-assignee="showAssignee"
    :hide-inbox-name="hideInboxName"
    enable-context-menu
    @select-conversation="selectConversation"
    @de-select-conversation="deSelectConversation"
    @assign-agent="assignAgent"
    @assign-team="assignTeam"
    @assign-label="assignLabels"
    @remove-label="removeLabels"
    @update-conversation-status="updateConversationStatus"
    @context-menu-toggle="toggleContextMenu"
    @mark-as-unread="markAsUnread"
    @mark-as-read="markAsRead"
    @assign-priority="assignPriority"
    @delete-conversation="deleteConversation"
  />
</template>
